import { render, staticRenderFns } from "./InStoreAppointmentsTableDetails.vue?vue&type=template&id=55326b8b&scoped=true"
import script from "./InStoreAppointmentsTableDetails.vue?vue&type=script&lang=js"
export * from "./InStoreAppointmentsTableDetails.vue?vue&type=script&lang=js"
import style0 from "./InStoreAppointmentsTableDetails.vue?vue&type=style&index=0&id=55326b8b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55326b8b",
  null
  
)

export default component.exports